/* istanbul ignore file */
export const env = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? 'https://api.staging.myautochek.com',
  talentchekApiBaseUrl:
    import.meta.env.VITE_TALENTCHEK_API_BASE_URL ?? 'https://talentchek-api.autochek.africa',
  firebaseApiKey: import.meta.env.VITE_FIREBASE_API_KEY ?? '',
  firebaseAuthDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN ?? '',
  policyUploadEmail: import.meta.env.VITE_POLICY_UPLOAD_EMAIL ?? '',
  policyUploadPassword: import.meta.env.VITE_POLICY_UPLOAD_PASSWORD ?? '',
  policyUploadStorageProvider: import.meta.env.VITE_POLICY_UPLOAD_STORAGE_PROVIDER ?? 'gcs',
  policyUploadIpAddress: import.meta.env.VITE_POLICY_UPLOAD_IP_ADDRESS ?? '',
  appName: import.meta.env.VITE_APP_NAME ?? 'Talentchek',
  appVersion: import.meta.env.VITE_APP_VERSION ?? '1.0.0',
  defaultLocale: import.meta.env.VITE_DEFAULT_LOCALE ?? 'en',
  sentryDsn: import.meta.env.VITE_SENTRY_DSN ?? '',
  isDev: import.meta.env.DEV,
  isProd: import.meta.env.PROD,
} as const;

export function validateUploadCredentials(): { valid: boolean; error?: string } {
  const missing: string[] = [];
  if (!env.policyUploadEmail) missing.push('VITE_POLICY_UPLOAD_EMAIL');
  if (!env.policyUploadPassword) missing.push('VITE_POLICY_UPLOAD_PASSWORD');
  if (!env.policyUploadStorageProvider) missing.push('VITE_POLICY_UPLOAD_STORAGE_PROVIDER');
  
  if (missing.length > 0) {
    return {
      valid: false,
      error: `Document upload not configured. Missing environment variables: ${missing.join(', ')}. Please contact your administrator.`
    };
  }
  return { valid: true };
}
